// 跳转路径

export function Index () {
  return '/';
}

export function Home () {
  return '/home';
}

export function Error404 () {
  return '/error';
}
